import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const metricApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "metricApi",
  tagTypes: ["metric", "Answer"],
  endpoints: (builder) => ({
    userMetrics: builder.mutation<any, API.Payload.MetricPayload>({
      query: (payload) => ({
        url: `/metrics/summary/user`,
        method: "POST",
        body: payload,
      }),
    }),
    structuredTrend: builder.mutation<any, API.Payload.MetricPayload>({
      query: (payload) => ({
        url: `/metrics/trend`,
        method: "POST",
        body: payload,
      }),
    }),
    structuredRecord: builder.mutation({
      query: (payload) => ({
        url: `/metrics/records`,
        method: "POST",
        body: payload,
      }),
    }),

    deleteIncentiveMetric: builder.mutation({
      query: (payload) => ({
        url: "admin/incentive/metrics/delete",
        method: "POST",
        body: payload,
      }),
    }),

    uploadDataFile: builder.mutation<any, any>({
      query: ({ file, fileEndpoint }) => ({
        url: `/import/${fileEndpoint}`,
        method: "POST",
        body: file,
      }),
    }),

    uploadSSMStatus: builder.query<any, void>({
      query: () => "import/ssm/status",
    }),
  }),
})

export const {
  useUserMetricsMutation,
  useDeleteIncentiveMetricMutation,
  useStructuredRecordMutation,
  useStructuredTrendMutation,
  useUploadDataFileMutation,
  useUploadSSMStatusQuery,
} = metricApi
